<template>

  <div class="ui stackable two column grid container contato" >
    <div class="row titulo">
         <h2 class="ui header">
          <div class="title">CONTATO</div>
   
        </h2>
    </div>
    <div class="column">
      
            <h2 class="ui header">
Fale Conosco
<div class="sub header">
            <i class="phone icon"></i>
Telefone:<a :href="`tel:${dados.telefones.numero.replace(/ /g,'')}`">
          {{ dados.telefones.numero }}
        </a>
</div>
<div class="sub header">
            <i class="whatsapp icon"></i>
WhatsApp:             <a target="_blank" :href="`http://wa.me/055${dados.telefones.whatsapp.replace(/ /g,'')}`">{{dados.telefones.whatsapp}}</a>

</div>
<div class="sub header">
           <i class="mail icon"></i>
  E-mail:           
  <a :href="`mail:${dados.email.emailUm}`">  {{ dados.email.emailUm }}</a>


</div>

            </h2>

                    <h2 class="ui header">
Onde Estamos
<div class="sub header">
   {{dados.endereco.rua}}, {{dados.endereco.numero}} - {{dados.endereco.cidade}}, {{dados.endereco.estado}}
            <br>Cep {{dados.endereco.cep}}
            
            </div>

            </h2>

    </div>
    <div class="column" v-if="null">

         <h2 class="ui header">
          <div class="title">Envie sua mensagem
</div>
   
        </h2>
      <div class="ui form" style="width: 100%" >
        <div class="fields">
          <div class="field wide twelve">
            <label>Nome</label>
            <input type="text">
          </div>
      
          </div>
          <div class="fields">
                <div class="field wide six">
            <label>Telefone</label>
            <input type="text">
          </div>
          <div class="field wide six">
            <label>Endereço de email</label>
            <input type="text">
          </div>
          </div>
          <div class="fields">
          <div class="field wide six">
            <label>WhatsApp</label>
            <input type="text">
          </div>
          <div class="field wide nine">
            <label>Tratamento do seu Interesse</label>
            <input type="text">
          </div>
        </div>
        <div class="fields">
          
          <div class="field wide sixteen">
                        <label>Messagem</label>
                      <textarea></textarea>
          </div>
        </div>
        <a class="ui button">Enviar</a>
      </div></div>
          <div class="column">

      <GmapMap
  :center="{lat: -23.4493884, lng: -46.5463257}"
  :zoom="16"
  map-type-id="terrain"
  style="width: 100%; height: 450px"
   :options="{
   zoomControl: true,
   mapTypeControl: false,
   scaleControl: false,
   streetViewControl: false,
   rotateControl: false,
   fullscreenControl: true,
   disableDefaultUi: false
 }"
>
  <GmapMarker
    :key="index"
    v-for="(m, index) in markers"
    :position="m.position"
    :clickable="true"
    :draggable="true"
    @click="center=m.position"
    
  />
</GmapMap>
    </div>
</div>

  </template>

<script>
import { siteConfig } from '../dados.js'
export default {
data() {return {
  dados: siteConfig,
  markers: [{
    position: {
    lat: -23.4493884, lng: -46.5463257}
    }
  ]
}}
};
</script>
